import { type AppContext } from '@/main';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')<AppContext>({
  component: Outlet,
  loader: () => ({
    crumb: 'Authentication',
  }),
});

// function _AuthComponent() {
//   return (
//     <div className="max-w-md mx-auto mt-8 p-6 bg-red-500 border rounded-lg text-center">
//       <h1 className="text-white">Welcome to the Authentication Page</h1>
//       <Outlet />
//     </div>
//   );
// }
